import { CellData } from './cell-data';
import { DataMap } from './interfaces/data-map';

/**
 * This class represents a table data structure ready to be rendered.
 * I can be portfolio specific depending on the tab configuration specified in the component config.
 */
export class TableData {
	private rows: DataMap<CellData>[] = [];

	public static create(options: TableDataOptions): TableData {
		return new TableData(options.headersX, options.headersY, options.cells, options.portfolioData, options.firstColumnTitle, options.transposed);
	}

	constructor(
		public readonly headersX: CellData[],
		public readonly headersY: CellData[],
		public readonly cells: CellData[][],
		public readonly portfolioData: CellData[] = [],
		public readonly firstColumnTitle?: CellData,
		public readonly transposed = false
	) {
		try {
			for (let x = 0; x < this.cells.length; x++) {
				for (let y = 0; y < this.cells[x].length; y++) {
					const i = transposed ? x : y;
					const row = !transposed ? x : y;
					const cell = this.cells[x][y];
					if (!this.rows[row]) {
						this.rows[row] = {};
					}
					const id = cell.config ? cell.config.id : `_${i}`;
					if (this.rows[row][id]) {
						throw new Error(`Duplicate column ID detected ${id}, rows property on the TableData will be empty!`);
					}
					this.rows[row][id] = cell;
				}
			}
		} catch (err) {
			this.rows.splice(0, this.rows.length);
		}
	}

	public log(): void {
		const logOutput = this.cells.map((row, rowIndex) => {
			const output = { '(headerY)': this.headersY[rowIndex].formattedValue };
			row.forEach((cell, cellIndex) => (output[this.headersX[cellIndex].formattedValue] = cell.formattedValue));
			return output;
		});

		if (console.table) {
			// console.table doesn't exist in IE :(
			console.table(logOutput);
		} else {
			console.log(logOutput);
		}
	}
}

export interface TableDataOptions {
	headersX: CellData[];
	headersY: CellData[];
	cells: CellData[][];
	portfolioData: CellData[];
	firstColumnTitle?: CellData;
	transposed: boolean;
}

export class TableAttributes {
	public hasCategoryTopBorder?: boolean;
	public hideIcon?: boolean;
}
